import { useEffect, useState } from 'react';
import { isElementVisible } from 'util/isElementVisible';

/**
 * Detects if the ref element is visible in the screen after scroll event.
 * For example, the hook returns false when the element gets scrolled out of view.
 */
export const useIsInView = (
  ref: React.MutableRefObject<HTMLDivElement | null>,
  offsetTop: number
) => {
  const [isInView, setIsInView] = useState(false);

  useEffect(() => {
    if (ref.current !== null) {
      setIsInView(isElementVisible(ref.current, offsetTop));
    }
    const onScroll = () => {
      if (ref.current) {
        setIsInView(isElementVisible(ref.current, offsetTop));
      }
    };
    window.addEventListener('scroll', onScroll);

    return () => window.removeEventListener('scroll', onScroll);
  }, [offsetTop, ref]);

  const inViewRef = (node: HTMLDivElement | null) => {
    ref.current = node;
  };

  return { isInView, inViewRef };
};
